"use client";

import { Dialog } from "../Dialog/Dialog";
import type { ReactNode } from "react";
import { Button } from "../Button/Button";
import { XIcon } from "@ngg/icons";
import { cn } from "@/lib/utils";

export type CartProps = {
  open: boolean;
  hideCart: () => void;
  isEmpty?: boolean;
  dictionary: { [key: string]: string };
  classNames?: {
    panel?: string;
  };
  children: ReactNode;
  EmptyCart: ReactNode;
  CartFooter: ReactNode;
};

const CloseButton = (onClose: () => void, className?: string) => (
  <Button
    type="button"
    onClick={onClose}
    className={cn("border-0 bg-transparent p-0 text-black", className)}
  >
    <XIcon className="text-base" />
  </Button>
);

export function Cart(props: CartProps) {
  const {
    open,
    hideCart,
    isEmpty,
    dictionary,
    classNames,
    children,
    EmptyCart,
    CartFooter,
  } = props;
  return (
    <Dialog
      dialogTransitionProps={{
        enter: "ease-out duration-200",
        enterFrom: "translate-x-full",
        enterTo: "-translate-x-0",
        leave: "ease-in duration-200",
        leaveFrom: "-translate-x-0",
        leaveTo: "translate-x-full",
      }}
      title={dictionary?.yourCart}
      open={open}
      onClose={hideCart}
      CloseButton={() => CloseButton(hideCart, "px-2 py-4 m-0")}
      classNames={{
        panel: cn([
          "py-0 rounded-none scrollbar-none fixed m-0 top-0 pb-0 right-0 z-40 flex bottom-0 flex-col overflow-y-auto overflow-x-hidden bg-white w-full max-w-[480px]",
          classNames?.panel,
        ]),
        title: "font-bold text-lg leading-4 tracking-0.02em",
        panelHeader:
          "flex w-full items-center justify-between px-3 pr-0 text-sm font-semibold",
      }}
    >
      <hr className="border-grey-150" />
      {isEmpty ? (
        EmptyCart
      ) : (
        <>
          <div className="relative max-h-full basis-full overflow-y-auto scrollbar-none">
            {children}
          </div>
          {CartFooter}
        </>
      )}
    </Dialog>
  );
}
